import { OptionDto } from "@/dtos";
import { PaymentMethodStatus } from "@/helpers/types";

const paymentMethodsStatuses = [
    { value: PaymentMethodStatus.ACTIVE, label: 'Activo' },
    { value: PaymentMethodStatus.BLACK_LIST, label: 'Lista Negra' },
    { value: PaymentMethodStatus.TEMPORAL_BLOCK, label: 'Bloqueo Temporal' },
] as OptionDto[];

export const getPaymentMethodStatusOptions = (): OptionDto[] => {
    return paymentMethodsStatuses;
}

export const getPaymentMethodStatusOption = (value?: number): OptionDto => {
    return paymentMethodsStatuses.find((x) => x.value == value) ?? paymentMethodsStatuses[0];
}

export const getPaymentMethodStatusLabel = (value: number): string => {
    return paymentMethodsStatuses.find((x) => x.value == value)?.label ?? paymentMethodsStatuses[0].label;
}